<template>
  <div class="teams">
    <div class="page__header">
      <div class="page__title"> {{ $t(`users.${"team"}`) }}</div>
      <div class="page__right">

        <button
          v-if="instance.proxy.$checkRolePermission('team_create')"
          class="users__button button button--default"
          @click="store.commit('setShowAddTeamModal', true)"
        >
          {{ $t(`users.${"addTeamBtn"}`) }}
        </button>
      </div>
    </div>

    <div class="table">
      <Loading v-if="teamsLoading" />
      <template v-else>
        <NoData v-if="!teams.length" :type="'teams'" />
        <template v-else>
          <div class="table__header box box--default">
            <div class="table__label table__label--small team__logo"></div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"name"}`) }}
            </div>
            <div class="table__label table__label--medium">
              FINMA Nr.
            </div>
            <div class="table__label table__label--medium">
               {{ $t(`teams.${"tableHeader"}.${"domain"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"address"}`) }}
            </div>
            <div class="table__label table__label--large">
              {{ $t(`teams.${"tableHeader"}.${"mandateTypes"}`) }}
            </div>

            <div
              class="table__label table__label--small"
              v-if="instance.proxy.$checkRolePermission('team_delete')"
            ></div>
          </div>

          <div class="table__body">
            <Team
              v-for="team in teams"
              :key="team.id"
              :team="team"
              :deleteTeam="deleteTeam"
            />
          </div>
        </template>
      </template>
    </div>

  </div>
</template>

<script setup>
import { computed, onMounted, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import Team from "@/components/Teams/Team";
import Loading from "@/partials/Loading";
import NoData from "@/partials/NoData";

const store = useStore();
const router = useRouter();
const instance = getCurrentInstance();

// Computed properties
const teamsLoading = computed(() => store.getters.teamsLoading);
const teams = computed(() => store.getters.teams);
const loggedUser = computed(() => store.getters.loggedUser);

// Methods
const deleteTeam = ({ display, message, action, id }) => {
  store.commit("setDeleteModal", {
    display,
    message,
    action,
    id,
  });
};

// Lifecycle
onMounted(async () => {
  store.commit("setTeamsLoading", true);

  if (!loggedUser.value.is_super_admin) {
    router.push('/dashboard');
  } else {
    await store.dispatch("getTeams");
  }

  store.commit("setTeamsLoading", false);
});
</script>

<style scoped lang="scss">
.teams {
  height: 100%;

  &__button {
    width: 190px;
  }
  .table {
    margin-bottom: 20px;
    height: calc(100% - 40px - 20px - 20px - 30px);
   .table__label--small{
      max-width: 70px;
    }
    &--last {
      max-width: 45px;
      height: initial;
    }
   .team__logo {
     max-width: 70px;
   }
  }  
}
</style>
